import React from 'react';
import { useDocumentsLinksPresenter } from './DocumentsLinks.presenter';

import { Link } from 'components/uikit/Link/Link';

import * as S from '../SignPEP.styles';

export const DocumentsLinks = () => {
  const presenter = useDocumentsLinksPresenter();

  return (
    <S.DocumentsLinksWrap>
      {Object.keys(presenter.otpDocLink).length > 0 &&
      !presenter.otpDocLink['credit-history-data'] ? (
        <>
          {presenter.otpDocLink['personal-data'] && (
            <Link
              href="#"
              onClick={(e) => presenter.getOtpDocHandler(e, presenter.otpDocLink['personal-data'])}
            >
              {'Согласие СОПД'}
            </Link>
          )}
          {presenter.personalDataDoc && (
            <Link
              href="#"
              onClick={(e) => presenter.getOtpDocHandler(e, presenter.personalDataDoc.id)}
            >
              {'Согласие БКИ'}
            </Link>
          )}
        </>
      ) : (
        !presenter.isPEPSignature &&
        presenter.personalDataDoc && (
          <Link
            href="#"
            onClick={(e) => presenter.getOtpDocHandler(e, presenter.personalDataDoc.id)}
          >
            {'СОПД и БКИ'}
          </Link>
        )
      )}
    </S.DocumentsLinksWrap>
  );
};
